.f7{border:1px solid #ddd;}